<template>
  <wo-region>
    <wo-layout v-if="recommendation">
      <wo-spacer />
      <po-route-link :value="returnRoute" />
      <wo-title tag-name="h2">{{ recommendation.type.name }}</wo-title>
      <wo-grid>
        <wo-column width-md="8">
          <div v-for="component in recommendation.components" :key="component.id">
            <wo-card :title="component.name">
              <wo-properties mod-bordered mod-horizontal>
                <template v-for="(reco, i) in component.recommendations">
                  <wo-properties-label :key="reco.use"><wo-label>{{ reco.use }}</wo-label></wo-properties-label>
                  <wo-properties-value :key="i">
                    <template v-if="reco.intervals && reco.intervals.length">
                      <po-display :value="reco.intervals" />
                      <wo-spacer />
                    </template>
                    <ul class="wo-u-list-unstyled">
                      <li v-for="product in reco.products" :key="product.id" ><wo-link :href="product.url" target="_blank">{{ product.name }}</wo-link></li>
                    </ul>
                  </wo-properties-value>
                </template>
              </wo-properties>
            </wo-card>
            <wo-spacer />
          </div>
        </wo-column>
        <wo-column width-md="4">
          <wo-card :title="infoTitle">
            <wo-layout>
              <wo-region v-wo-align:center>
                <img :src="recommendation.type.image_url" />
              </wo-region>
            </wo-layout>
            <wo-properties mod-bordered>
              <wo-properties-label><wo-label v-t="'reco.recommendation.brand'" /></wo-properties-label>
              <wo-properties-value>{{ recommendation.brand.name }}</wo-properties-value>
              <wo-properties-label><wo-label v-t="'reco.recommendation.model'" /></wo-properties-label>
              <wo-properties-value>{{ recommendation.model.name }}</wo-properties-value>
            </wo-properties>
          </wo-card>
        </wo-column>
      </wo-grid>
    </wo-layout>
    <po-loading v-else mod-layover />
  </wo-region>
</template>
<script>

import { mapState } from 'vuex'

import { RECO_SEARCH } from '@/routes/product'
import { recoRecommendationRepository } from '@/repository/reco'

export default {
  props: {
    typeId: String,
    searchId: String
  },
  computed: mapState({
    recommendation: state => state.reco.recoRecommendation,
    infoTitle () {
      return this.$t('reco.recommendation.info')
    },
    returnRoute () {
      return { name: RECO_SEARCH }
    }
  }),
  created () {
    this.loadRecommendation()
  },
  methods: {
    loadRecommendation () {
      this.$store.dispatch(recoRecommendationRepository.find, { typeId: this.typeId, searchId: this.searchId })
    }
  }
}
</script>
